export const convertSignCode = (
  inputString: string
): {
  type: 'QR' | 'GTIN' | 'string';
  parsedStr: string;
  gtin: string | null;
} => {
  // минимальная нормализация: обрезаем и убираем AIM-префикс (]d2 / ]C1 и т.п.)
  let s = inputString.trim().replace(/^\](?:C1|c1|d2|D2)/, '');

  //классификация и извлечение GTIN
  let type: 'QR' | 'GTIN' | 'string' = 'string';
  let gtin: string | null = null;

  // GTIN без префикса 01: только цифры, длина 8..16
  if (/^\d{8,14}$/.test(s)) {
    type = 'GTIN';
    gtin = s;
  } else {
    const last93 = s.lastIndexOf('93');
    if (last93 !== -1) {
      const hasGS = last93 > 0 && s.charCodeAt(last93 - 1) === 29; // 29 == GS
      if (!hasGS) {
        s = s.slice(0, last93) + '\x1D' + s.slice(last93);
      }
    }
  }

  // Попытка распознать корректный QR:
  // 01 + 14 цифр (группа 1), затем 21, затем любой серийник без GS (группа 2),
  // затем GS и 93, затем криптохвост (группа 3)
  // eslint-disable-next-line no-control-regex
  const m = /^01(\d{14})21([^\x1D]*?)\x1D93(.+)$/.exec(s);
  if (m) {
    type = 'QR';
    gtin = m[1].replace(/^0+/, '');
  }

  return { type, parsedStr: s, gtin };
};
